import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getReferralSales(customerId, {
    startDate = null, endDate = null, page = 1, perPage = 20,
  } = {}) {
    const params = { page, perPage }
    if (startDate) params.startDate = startDate
    if (endDate) params.endDate = endDate

    return axiosIns.get(`/waiter/customers/${customerId}/referral_sales`, {
      params: snakecaseKeys(params),
    })
  },

  getReferralTree(customerId) {
    return axiosIns.get(`/waiter/customers/${customerId}/referral_tree`)
  },

  createReferral({ referrerId, referredId }) {
    return axiosIns.post('/waiter/customer_referrals', snakecaseKeys({
      customerReferral: { referrerId, referredId },
    }))
  },

  deleteReferral(id) {
    return axiosIns.delete(`/waiter/customer_referrals/${id}`)
  },
}
